import React from 'react'
import { Box, SxProps } from '@mui/material'

interface Props {
  sxStyle?: SxProps
  children?: React.ReactNode
}

const PaperContent: React.FC<Props> = ({ sxStyle, children }) => {
  return <Box sx={sxStyle}>{children}</Box>
}

export default PaperContent
